import {cloneDeep, find, set, get, replace } from "lodash";
import { useEffect, useState, Fragment } from "react";
import { BTN_CLS } from "../../../constants/var.constants";
import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT } from "../../../constants/var.constants";
import FaIcons from "../../common/FaIcons";
import {Button} from "../../ui/com_ui";
import ToggleBtn from"../site-settings/ui/ToggleBtn";
import copy from 'copy-to-clipboard';

//import createEncryptor from 'simple-encryptor'


const PageRedirect = ({ sitesettings, updateSettings }) => {
  const {visibleTo, redirectType='', redirectUrl=''} = sitesettings
  const updateItem = (key, value) => {
    const sst = cloneDeep(sitesettings);
    const data = set(sst, key, value);
    updateSettings(data);
  };
  
  const Enable = () => {
    return(
      <div className={twdClass("flex items-center mb-2")}>
        <label className={twdClass("w-40 text-sm")}>
          Redirect Type        
        </label>
        <div className={twdClass("flex-1")}>
        <select
            className={twdClass(INPUT_TEXT)}
            onChange={(e) => updateItem("redirectType", e.target.value)}
            value={redirectType}
          >
            <option value="">None</option>
            <option value={'url'}>Url</option>
          </select>
          {/*<ToggleBtn
            toggleId={"showfilter"}
            value={redirectTo}
            falseLabel={`Off`}
            trueLabel="On"
            updateValue={(value) => {
              //console.log("manifest", value)
              updateItem("redirectTo", value);
            }}
          />*/}
        </div>
      </div>        
    )
  }
  const Input = () => {
    return (
      <div className={twdClass("flex items-center mb-2")}>
        <label className={twdClass("w-40 text-sm")}>
          Visibility          
        </label>
        <div className={twdClass("flex-1")}>
          <textarea
            rows={2}
            value={redirectUrl}
            className={twdClass(`${INPUT_TEXT} w-full`)}
            onChange={(e) => updateItem("redirectUrl", e.target.value)}
            placeholder = {`https://www.domainname.com/`}
          ></textarea>
          {/*<select
            className={twdClass(INPUT_TEXT)}
            onChange={(e) => updateItem("visibleTo", e.target.value)}
            value={visibleTo}
          >
            <option value="">Select</option>
            <option value={'guest'}>Visible to Users</option>
            <option value={'not_visible'}>Not visible to users</option>
          </select>*/}
        </div>
      </div>
    );
  };


  return (
    <div className={twdClass("flex flex-col")}>   
      <div className={twdClass("flex items-center mb-2")}>
        <label className={twdClass("w-40 text-sm")}>
          Redirect Type        
        </label>
        <div className={twdClass("flex-1")}>
        <select
            className={twdClass(INPUT_TEXT)}
            onChange={(e) => updateItem("redirectType", e.target.value)}
            value={redirectType}
          >
            <option value="">None</option>
            <option value={'url'}>Url</option>
          </select>
          {/*<ToggleBtn
            toggleId={"showfilter"}
            value={redirectTo}
            falseLabel={`Off`}
            trueLabel="On"
            updateValue={(value) => {
              //console.log("manifest", value)
              updateItem("redirectTo", value);
            }}
          />*/}
        </div>
      </div>      
      {redirectType=='url' && <div className={twdClass("flex items-center mb-2")}>
        <label className={twdClass("w-40 text-sm")}>
          Redirect Url          
        </label>
        <div className={twdClass("flex-1")}>
          <textarea
            rows={2}
            value={redirectUrl}
            className={twdClass(`${INPUT_TEXT} w-full`)}
            onChange={(e) => updateItem("redirectUrl", e.target.value)}
            placeholder = {`https://www.domainname.com/`}
          ></textarea>
          {/*<select
            className={twdClass(INPUT_TEXT)}
            onChange={(e) => updateItem("visibleTo", e.target.value)}
            value={visibleTo}
          >
            <option value="">Select</option>
            <option value={'guest'}>Visible to Users</option>
            <option value={'not_visible'}>Not visible to users</option>
          </select>*/}
        </div>
      </div>}
    </div>  
  );
};

export default PageRedirect;
